import type { Founder, FooterColumn, InfoRow, ListCard, Product, SupportCard } from '../types/content';

export const company = {
  name: 'Massive Faith LLC',
  email: 'info@massivefaith.site',
  phone: '+1 (786) 516-7314',
  phoneHref: 'tel:+17865167314',
  hours: 'Lunes a viernes, 9:00 a 18:00 (GMT-3)',
  descriptor: 'MASSIVE FAITH LLC',
  supportMailto: 'mailto:info@massivefaith.site?subject=Consulta%20de%20soporte',
  refundMailto: 'mailto:info@massivefaith.site?subject=Solicitud%20de%20reembolso',
};

export const navLinks = [
  { label: 'Empresa', href: '#empresa' },
  { label: 'Qué vendemos', href: '#negocio' },
  { label: 'Producto', href: '#productos' },
  { label: 'Entrega', href: '#entrega' },
  { label: 'Reembolsos', href: '#reembolsos' },
  { label: 'Términos', href: '#terminos' },
  { label: 'English', href: '#english' },
];

export const heroLead =
  '**Massive Faith LLC** es una empresa registrada en Wyoming, Estados Unidos, dedicada exclusivamente a la **venta de productos digitales**. Hoy comercializamos un único producto: el **kit de libros digitales «La Ley de Murphy»** (3 libros en PDF con formato de cómic educativo) bajo la marca **Padres Responsables** en español y **Responsible Parents** en inglés. Se paga una sola vez y se entrega al instante por email. **No vendemos ni enviamos productos físicos** y **no operamos suscripciones ni cobros recurrentes**.';

export const heroFacts = [
  { label: 'Razón social', value: 'Massive Faith LLC' },
  { label: 'Soporte', value: 'info@massivefaith.site' },
  { label: 'Garantía', value: '30 días' },
  { label: 'Entrega', value: 'Digital e inmediata (PDF por email)' },
];

export const companyRows: InfoRow[] = [
  { label: 'Razón social', lines: [{ text: 'Massive Faith LLC' }] },
  { label: 'Marcas comerciales', lines: [{ text: 'Padres Responsables (español)' }, { text: 'Responsible Parents (inglés)' }] },
  { label: 'Tipo de entidad', lines: [{ text: 'Limited Liability Company (LLC), Wyoming, EE. UU.' }] },
  { label: 'EIN (Tax ID)', lines: [{ text: '39-5048643' }] },
  { label: 'Fecha de constitución', lines: [{ text: '23 de octubre de 2025' }] },
  { label: 'Domicilio comercial', lines: [{ text: '1057 NW 136th Ave' }, { text: 'Miami, FL 33182' }, { text: 'Estados Unidos' }] },
  { label: 'Agente registrado', lines: [{ text: 'Registered Agents Inc — 30 N Gould St, Suite R, Sheridan, WY 82801' }] },
  { label: 'Miembros', lines: [{ text: 'Alejo Lautaro Martinez Avellaneda (50 %)' }, { text: 'Tomas Ivan Martinez Avellaneda (50 %)' }] },
];

export const contactRows: InfoRow[] = [
  { label: 'Email de soporte', lines: [{ text: 'info@massivefaith.site', href: 'mailto:info@massivefaith.site' }] },
  { label: 'Teléfono', lines: [{ text: '+1 (786) 516-7314', href: 'tel:+17865167314' }] },
  { label: 'Horario de atención', lines: [{ text: 'Lunes a viernes, 9:00 a 18:00 (GMT-3)' }] },
  { label: 'Sitio web oficial', lines: [{ text: 'info.massivefaith.site', href: 'https://info.massivefaith.site' }] },
  {
    label: 'Tiendas online',
    lines: [
      { text: 'padresresponsables.com', href: 'https://padresresponsables.com' },
      { text: 'englishstore.online', href: 'https://www.englishstore.online/pages/raise-a-child' },
    ],
  },
  { label: 'Cargo en el extracto bancario', lines: [{ text: 'MASSIVE FAITH LLC' }] },
  { label: 'Moneda de cobro', lines: [{ text: 'USD (dólar estadounidense)' }] },
];

export const chargeNotice =
  '**¿Ves un cargo que no reconocés en tu tarjeta?** Puede aparecer como **MASSIVE FAITH LLC**. Corresponde a la compra del kit de libros digitales de Padres Responsables / Responsible Parents. Antes de abrir una disputa con tu banco, escribinos a [info@massivefaith.site](mailto:info@massivefaith.site): identificamos la operación y, si corresponde, te devolvemos el importe directamente. Es mucho más rápido que un contracargo.';

export const founders: Founder[] = [
  {
    initials: 'AM',
    name: 'Alejo Lautaro Martinez Avellaneda',
    role: 'Cofundador · Miembro (50 %) · Representante de la cuenta',
    bio: 'Dirige el marketing digital, las tiendas online y la publicación del producto. Supervisa el contenido y las actualizaciones del kit de libros y la atención a clientes.',
  },
  {
    initials: 'TM',
    name: 'Tomas Ivan Martinez Avellaneda',
    role: 'Cofundador · Miembro (50 %)',
    bio: 'Codirige la empresa junto con Alejo y comparte la responsabilidad sobre la operación, la administración y el cumplimiento de las políticas publicadas en esta página.',
  },
];

export const businessCards: ListCard[] = [
  {
    tag: 'Único producto',
    title: 'Kit digital «La Ley de Murphy»',
    description:
      'Un kit de 3 libros digitales en PDF, con formato de cómic educativo, para chicos de 6 a 12 años. Enseña habilidades para la vida real: manejo de la frustración y del error, curiosidad y conocimiento general, y liderazgo. Se vende en nuestras tiendas online propias, en español e inglés, y se entrega por email apenas se confirma el pago.',
    items: [
      'Precio: **US$ 18,90** (pago único)',
      '3 libros en PDF, descargables e imprimibles',
      'Sin suscripción ni cargos recurrentes',
      'Garantía de 30 días',
    ],
    foot: 'Detalle completo en [Producto](#productos).',
  },
  {
    tag: 'Cómo cobramos',
    title: 'Modelo de cobro',
    description:
      'Todos los cobros son **pagos únicos** que el cliente autoriza en el checkout. **No operamos suscripciones, membresías con renovación automática ni pruebas gratuitas que se conviertan en cargos.** Nunca hacemos un cobro que el cliente no haya autorizado expresamente.',
    items: [
      'Moneda: **USD**',
      'Clientes: madres, padres, familiares y docentes (adultos)',
      'Mercados: Latinoamérica, España, Estados Unidos, Reino Unido, Canadá, Irlanda y Nueva Zelanda',
      'Canal de venta: solo nuestras tiendas online propias',
      'Extracto bancario: **MASSIVE FAITH LLC**',
    ],
    foot: 'Datos completos del vendedor en [Datos de la empresa](#empresa).',
  },
  {
    tag: 'Qué NO hacemos',
    title: 'Fuera de nuestra actividad',
    description:
      'Para que no quede ninguna duda sobre la naturaleza del negocio, dejamos constancia de todo lo que **no** forma parte de nuestra operación.',
    items: [
      'No vendemos, fabricamos ni enviamos **productos físicos**.',
      'No cobramos **suscripciones** ni renovaciones automáticas.',
      'No ofrecemos **pruebas gratuitas** que se conviertan en un cargo.',
      'No vendemos a través de **terceros** ni de marketplaces.',
      'No vendemos a menores: el comprador siempre es un adulto.',
      'No brindamos asesoramiento psicológico, médico, pedagógico, legal ni financiero.',
    ],
    foot: 'Condiciones completas en [Términos y Condiciones](#terminos).',
  },
];

export const products: Product[] = [
  {
    tag: 'Kit de 3 libros digitales · PDF · Español',
    title: '3X1 — Criá un hijo que sabe más, piensa mejor y se anima a liderar',
    description:
      'Kit de libros digitales en formato cómic para chicos de 6 a 12 años. Se entrega como archivos PDF por email, para leer en pantalla o imprimir en casa.',
    books: [
      '**La Ley de Murphy — Habilidades para la Vida** (libro principal): 28 reglas, 42 ejercicios prácticos y 125 ejemplos reales sobre cómo manejar la frustración, aprender de los errores y resolver problemas.',
      '**100.000 Porqués**: enciclopedia ilustrada en cómic que responde las preguntas de los chicos sobre ciencia, naturaleza y el mundo.',
      '**Liderazgo para Chicos**: comunicación, cooperación, empatía y hablar en público, en formato cómic.',
    ],
    price: 'US$ 18,90',
    was: 'US$ 35,00',
    storeLabel: 'padresresponsables.com',
    storeHref: 'https://padresresponsables.com',
  },
  {
    tag: '3-book digital kit · PDF · English',
    title: '3-in-1 Kit — Raise a Child (Responsible Parents)',
    description:
      'La versión en inglés del mismo kit, para chicos de 6 a 12 años. Se entrega como archivos PDF por email, para leer en pantalla o imprimir en casa.',
    books: [
      "**Murphy's Law for Kids** (libro principal): habilidades para la vida, manejo de la frustración y resolución de problemas.",
      '**The Big Book of Why**: respuestas ilustradas a las preguntas de los chicos sobre cómo funciona el mundo.',
      '**Leadership Starts Here**: comunicación, trabajo en equipo, empatía y confianza.',
    ],
    price: 'US$ 18,90',
    was: 'US$ 35,00',
    storeLabel: 'englishstore.online/pages/raise-a-child',
    storeHref: 'https://www.englishstore.online/pages/raise-a-child',
  },
];

export const addonsNotice =
  '**Complementos opcionales.** Durante la compra podemos ofrecer complementos digitales opcionales relacionados con el kit (material adicional en PDF). Siempre se muestran con su precio, se cobran como pago único **solo si el cliente los acepta expresamente** y se rigen por las mismas condiciones de esta página: entrega digital inmediata por email, garantía de 30 días y el mismo canal de soporte. Nunca agregamos cargos que el cliente no haya aceptado.';

export const deliveryCards: ListCard[] = [
  {
    title: 'Plazos de entrega',
    items: [
      '**Plazo:** inmediato. En la mayoría de los casos el email llega en menos de 5 minutos después de confirmado el pago.',
      '**Medio:** correo electrónico a la dirección indicada en la compra, con los enlaces de descarga de los PDF.',
      '**Plazo máximo garantizado:** si por un problema técnico el email no llega, lo resolvemos dentro de las 24 horas hábiles siguientes al reclamo.',
      '**Costo de envío:** US$ 0. No aplica.',
    ],
    foot: '¿No recibiste tus libros? Revisá la carpeta de spam o promociones y escribinos a [info@massivefaith.site](mailto:info@massivefaith.site).',
  },
  {
    title: 'Formato del material',
    items: [
      '**PDF descargable:** los 3 libros del kit, en archivos PDF a color.',
      '**Lectura:** en celular, tablet o computadora, o impresos en casa.',
      '**Vigencia:** los archivos descargados quedan en poder del cliente para su uso personal. Recomendamos guardarlos apenas se reciben.',
    ],
    foot: 'Todo el material es 100 % digital. No se envía nada por correo postal.',
  },
  {
    title: 'Requisitos técnicos',
    items: [
      'Conexión a internet y un dispositivo con navegador web.',
      'Un lector de PDF (viene incluido en casi todos los dispositivos).',
      'Una dirección de email válida: es el canal por el que se entrega el producto.',
    ],
    foot: 'No hace falta ningún software pago adicional.',
  },
];

export const refundSteps = [
  'Escribinos a [info@massivefaith.site](mailto:info@massivefaith.site) (o respondé el email de confirmación de tu pedido) dentro de los 30 días de la compra.',
  'Indicá el **email de compra** o el **número de pedido** y contanos brevemente por qué el material no te sirvió.',
  'Confirmamos que recibimos tu pedido dentro de las **24 horas hábiles**.',
  'Procesamos el reembolso en un plazo máximo de **5 días hábiles**, al mismo medio de pago de la compra.',
  'El dinero puede tardar entre **5 y 10 días hábiles** más en verse acreditado, según tu banco o emisor de tarjeta.',
];

export const fairUseRules = [
  'Se admite **un reembolso por cliente** (mismo email o mismo medio de pago).',
  'Al hacer el reembolso se revoca la licencia de uso: el cliente se compromete a borrar los archivos descargados y a no compartirlos.',
  'Podemos rechazar una solicitud cuando haya evidencia de uso abusivo de la garantía: por ejemplo, compras repetidas con pedidos sistemáticos de reembolso o redistribución del material a terceros. En ese caso lo comunicamos por escrito al cliente, con la explicación y la evidencia correspondiente.',
];

export const supportCards: SupportCard[] = [
  {
    tag: 'Email · Canal principal',
    value: 'info@massivefaith.site',
    href: 'mailto:info@massivefaith.site',
    description: 'Para cualquier consulta, incluidos los pedidos de reembolso y las dudas sobre un cargo. Respuesta dentro de las 24 horas hábiles.',
  },
  {
    tag: 'Teléfono',
    value: '+1 (786) 516-7314',
    href: 'tel:+17865167314',
    description: 'Atención telefónica para clientes y consultas antes de la compra, en horario de atención.',
  },
  {
    tag: 'Horario y tiempos',
    value: 'Lunes a viernes, 9:00 a 18:00 (GMT-3)',
    description: 'Los mensajes que llegan fuera de horario se responden el siguiente día hábil.',
  },
  {
    tag: 'Domicilio comercial',
    value: 'Massive Faith LLC',
    description: '1057 NW 136th Ave, Miami, FL 33182, Estados Unidos',
  },
  {
    tag: 'Cargo en tu tarjeta',
    value: 'MASSIVE FAITH LLC',
    description: 'Así aparece nuestro cobro en tu resumen bancario o de tarjeta.',
  },
  {
    tag: 'Idiomas de atención',
    value: 'Español e inglés',
    description: 'Atendemos a clientes de Latinoamérica, España, Estados Unidos, Reino Unido, Canadá, Irlanda y Nueva Zelanda.',
  },
];

export const footerColumns: FooterColumn[] = [
  {
    title: 'Massive Faith LLC',
    lines: [
      { text: 'Venta de libros digitales para chicos.' },
      { text: '1057 NW 136th Ave' },
      { text: 'Miami, FL 33182' },
      { text: 'Estados Unidos' },
      { text: 'EIN 39-5048643 · Wyoming LLC' },
    ],
  },
  {
    title: 'Atención al cliente',
    lines: [
      { text: 'info@massivefaith.site', href: 'mailto:info@massivefaith.site' },
      { text: '+1 (786) 516-7314', href: 'tel:+17865167314' },
      { text: 'Lunes a viernes, 9:00 a 18:00 (GMT-3)' },
    ],
  },
  {
    title: 'Políticas',
    lines: [
      { text: 'Reembolsos y cancelaciones', href: '#reembolsos' },
      { text: 'Entrega y envíos', href: '#entrega' },
      { text: 'Términos y Condiciones', href: '#terminos' },
      { text: 'Política de Privacidad', href: '#privacidad' },
      { text: 'Contactar soporte', href: '#soporte' },
    ],
  },
  {
    title: 'Nuestros sitios',
    lines: [
      { text: 'info.massivefaith.site', href: 'https://info.massivefaith.site' },
      { text: 'padresresponsables.com', href: 'https://padresresponsables.com' },
      { text: 'englishstore.online', href: 'https://www.englishstore.online/pages/raise-a-child' },
    ],
  },
];
